import {chkObject} from "./components/utils/Utils";
import {proxy} from "valtio";

export const state = proxy({
  usecases:[ {name:"Bin",children:null}, {name:"Cycle", children:[{name:"Bike Stands", children:null},{name:"Semi-Vertical",children:null},{name:"Two-Tier Racks",children:null}]}/* {name:"Empty",children:null}, {name:"Scooter",children:null},*/],
  usecase:"Empty",
  dimensions:[
    {dimension:[24,26], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"6no. SV"}], width:2550, depth:2450 },
    {dimension:[24,32], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"8no. SV"}],  width:3150, depth:2450},
    // {dimension:[24,38], usecases:[],  width:3750, depth:2450},
    {dimension:[24,44], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"12no. SV"}],  width:4350, depth:2450},
    {dimension:[24,50], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"14no. SV"}],width:4950, depth:2450},
    {dimension:[24,56], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"16no. SV"}],  width:5550, depth:2450},
    {dimension:[24,62], usecases:[],  width:6150, depth:2450},
    {dimension:[24,68], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"18no. SV"}],  width:6750, depth:2450},
    {dimension:[24,74], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"20no. SV"}],width:7350, depth:2450},
    {dimension:[24,80], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"22no. SV"}],  width:7950, depth:2450},
    {dimension:[24,86], usecases:[],  width:8550, depth:2450},
    {dimension:[24,92], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"26no. SV"}],  width:9150, depth:2450},
    {dimension:[24,98], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"28no. SV"}],width:9750, depth:2450},
    {dimension:[24,104], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"30no. SV"}],  width:10350, depth:2450},
    {dimension:[24,110], usecases:[],  width:10950, depth:2450},
    {dimension:[24,116], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"34no. SV"}],  width:11550, depth:2450},
    {dimension:[24,122], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"36no. SV"}], width:12150, depth:2450},
    {dimension:[24,128], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"38no. SV"}],   width:12750, depth:2450},
    {dimension:[24,134], usecases:[],   width:13350, depth:2450},
    {dimension:[24,140], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"42no. SV"}],   width:13950, depth:2450},
    {dimension:[24,146], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"44no. SV"}], width:14550, depth:2450},
    {dimension:[24,152], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"46no. SV"}],   width:15150, depth:2450},

    {dimension:[30,26], usecases:[{use:"Bike Stands", code:"PCH", capacity:"6no. Hoop"}, {use:"Scooter", code:"PSH", capacity:"2no. Scooter"}],width:2550, depth:3050},
    {dimension:[30,32], usecases:[{use:"Bike Stands", code:"PCH", capacity:"8no. Hoop"}],    width:3150, depth:3050},
    // {dimension:[30,38], usecases:[{use:"Scooter", code:"PSH", capacity:"3no. Scooter"}],    width:3750, depth:3050},
    {dimension:[30,44], usecases:[{use:"Bike Stands", code:"PCH", capacity:"10no. Hoop"}],    width:4350, depth:3050},
    {dimension:[30,50], usecases:[{use:"Bike Stands", code:"PCH", capacity:"12no. Hoop"}, {use:"Scooter", code:"PSH", capacity:"4no. Scooter"}],  width:4950, depth:3050},
    {dimension:[30,56], usecases:[{use:"Bike Stands", code:"PCH", capacity:"14no. Hoop"}],    width:5550, depth:3050},
    {dimension:[30,62], usecases:[{use:"Scooter", code:"PSH", capacity:"5no. Scooter"}],    width:6150, depth:3050},
    {dimension:[30,68], usecases:[{use:"Bike Stands", code:"PCH", capacity:"16no. Hoop"}],    width:6750, depth:3050},
    {dimension:[30,74], usecases:[{use:"Bike Stands", code:"PCH", capacity:"18no. Hoop"}, {use:"Scooter", code:"PSH", capacity:"6no. Scooter"}],  width:7350, depth:3050},
    {dimension:[30,80], usecases:[{use:"Bike Stands", code:"PCH", capacity:"20no. Hoop"}],    width:7950, depth:3050},
    {dimension:[30,86], usecases:[{use:"Scooter", code:"PSH", capacity:"7no. Scooter"}],    width:8550, depth:3050},
    {dimension:[30,92], usecases:[{use:"Bike Stands", code:"PCH", capacity:"22no. Hoop"}],    width:9150, depth:3050},
    {dimension:[30,98], usecases:[{use:"Bike Stands", code:"PCH", capacity:"24no. Hoop"}, {use:"Scooter", code:"PSH", capacity:"8no. Scooter"}],  width:9750, depth:3050},
    {dimension:[30,104], usecases:[{use:"Bike Stands", code:"PCH", capacity:"26no. Hoop"}],    width:10350, depth:3050},
    {dimension:[30,110], usecases:[{use:"Scooter", code:"PSH", capacity:"9no. Scooter"}],    width:10950, depth:3050},
    {dimension:[30,116], usecases:[{use:"Bike Stands", code:"PCH", capacity:"28. Hoop"}],    width:11550, depth:3050},
    {dimension:[30,122], usecases:[{use:"Bike Stands", code:"PCH", capacity:"30no. Hoop"}, {use:"Scooter", code:"PSH", capacity:"10no. Scooter"}],   width:12150, depth:3050},
    {dimension:[30,128], usecases:[{use:"Bike Stands", code:"PCH", capacity:"32no. Hoop"}],     width:12750, depth:3050},
    {dimension:[30,134], usecases:[{use:"Scooter", code:"PSH", capacity:"11no. Scooter"}],     width:13350, depth:3050},
    {dimension:[30,140], usecases:[{use:"Bike Stands", code:"PCH", capacity:"34no. Hoop"}],     width:13950, depth:3050},
    {dimension:[30,146], usecases:[{use:"Bike Stands", code:"PCH", capacity:"36no. Hoop"}, {use:"Scooter", code:"PSH", capacity:"12no. Scooter"}],   width:14550, depth:3050},
    {dimension:[30,152], usecases:[{use:"Bike Stands", code:"PCH", capacity:"38no. Hoop"}],     width:15150, depth:3050},

    {dimension:[36,26], usecases:[{use:"Bin", code:"PBH", capacity:""}],width:2550, depth:3650},
    {dimension:[36,32], usecases:[{use:"Bin", code:"PBH", capacity:""}],  width:3150, depth:3650},
    {dimension:[36,38], usecases:[],  width:3750, depth:3650},
    {dimension:[36,44], usecases:[],  width:4350, depth:3650},
    {dimension:[36,50], usecases:[{use:"Bin", code:"PBH", capacity:""}],width:4950, depth:3650},
    {dimension:[36,56], usecases:[],  width:5500, depth:3650},
    {dimension:[36,62], usecases:[{use:"Bin", code:"PBH", capacity:""}],  width:6150, depth:3650},
    {dimension:[36,68], usecases:[],  width:6750, depth:3650},
    {dimension:[36,74], usecases:[{use:"Bin", code:"PBH", capacity:""}],width:7350, depth:3650},
    {dimension:[36,80], usecases:[],  width:7950, depth:3650},
    {dimension:[36,86], usecases:[],  width:8550, depth:3650},
    {dimension:[36,92], usecases:[{use:"Bin", code:"PBH", capacity:""}],  width:9150, depth:3650},
    {dimension:[36,98], usecases:[],width:9750, depth:3650},
    {dimension:[36,104], usecases:[],  width:10350, depth:3650},
    {dimension:[36,110], usecases:[],  width:10950, depth:3650},
    {dimension:[36,116], usecases:[],  width:11550, depth:3650},
    {dimension:[36,122], usecases:[], width:12150, depth:3650},
    {dimension:[36,128], usecases:[],   width:12750, depth:3650},
    {dimension:[36,134], usecases:[],   width:13350, depth:3650},
    {dimension:[36,140], usecases:[],   width:13950, depth:3650},
    {dimension:[36,146], usecases:[], width:14550, depth:3650},
    {dimension:[36,152], usecases:[],   width:15150, depth:3650},

    {dimension:[42,26], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"10no. T2"}],width:2550, depth:4250},
    {dimension:[42,32], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"14no. T2"}],  width:3150, depth:4250},
    {dimension:[42,38], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"16no. T2"}],  width:3750, depth:4250},
    {dimension:[42,44], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"18no. T2"}],  width:4350, depth:4250},
    {dimension:[42,50], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"22no. T2"}],width:4950, depth:4250},
    {dimension:[42,56], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"26no. T2"}],  width:5500, depth:4250},
    {dimension:[42,62], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"28no. T2"}],  width:6150, depth:4250},
    {dimension:[42,68], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"32no. T2"}],  width:6750, depth:4250},
    {dimension:[42,74], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"34no. T2"}],width:7350, depth:4250},
    {dimension:[42,80], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"36no. T2"}],  width:7950, depth:4250},
    {dimension:[42,86], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"40no. T2"}],  width:8550, depth:4250},
    {dimension:[42,92], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"44no. T2"}],  width:9150, depth:4250},
    {dimension:[42,98], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"46no. T2"}],width:9750, depth:4250},
    {dimension:[42,104], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"48no. T2"}],  width:10350, depth:4250},
    {dimension:[42,110], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"50no. T2"}],  width:10950, depth:4250},
    {dimension:[42,116], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"54no. T2"}],  width:11550, depth:4250},
    {dimension:[42,122], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"56no. T2"}], width:12150, depth:4250},
    {dimension:[42,128], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"60no. T2"}],   width:12750, depth:4250},
    {dimension:[42,134], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"64no. T2"}],   width:13350, depth:4250},
    {dimension:[42,140], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"66no. T2"}],   width:13950, depth:4250},
    {dimension:[42,146], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"68no. T2"}], width:14550, depth:4250},
    {dimension:[42,152], usecases:[{use:"Two-Tier Racks", code:"PCHT", capacity:"72no. T2"}],   width:15150, depth:4250},

    {dimension:[48,26], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"12no. SV"},{use:"Hoop", code:"PCH", capacity:"12no. Hoop"},{use:"Scooter", code:"PSH", capacity:"4no. Scooter"},{use:"Bin", code:"PBH", capacity:""}],width:2550, depth:4850},
    {dimension:[48,32], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"16no. SV"},{use:"Hoop", code:"PCH", capacity:"16no. Hoop"}],  width:3150, depth:4850},
    {dimension:[48,38], usecases:[{use:"Scooter", code:"PSH", capacity:"6no. Scooter"},{use:"Bin", code:"PBH", capacity:""}],  width:3750, depth:4850},
    {dimension:[48,44], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"24no. SV"},{use:"Hoop", code:"PCH", capacity:"20no. Hoop"}],  width:4350, depth:4850},
    {dimension:[48,50], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"28no. SV"},{use:"Hoop", code:"PCH", capacity:"24no. Hoop"},{use:"Scooter", code:"PSH", capacity:"8no. Scooter"},{use:"Bin", code:"PBH", capacity:""}],width:4950, depth:4850},
    {dimension:[48,56], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"32no. SV"},{use:"Hoop", code:"PCH", capacity:"28no. Hoop"}],  width:5500, depth:4850},
    {dimension:[48,62], usecases:[{use:"Scooter", code:"PSH", capacity:"10no. Scooter"},{use:"Bin", code:"PBH", capacity:""}],  width:6150, depth:4850},
    {dimension:[48,68], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"36no. SV"},{use:"Hoop", code:"PCH", capacity:"32no. Hoop"}],  width:6750, depth:4850},
    {dimension:[48,74], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"40no. SV"},{use:"Hoop", code:"PCH", capacity:"36no. Hoop"},{use:"Scooter", code:"PSH", capacity:"12no. Scooter"},{use:"Bin", code:"PBH", capacity:""}],width:7350, depth:4850},
    {dimension:[48,80], usecases:[{use:"Semi-VerticalV", code:"PCH", capacity:"44no. SV"},{use:"Hoop", code:"PCH", capacity:"40no. Hoop"}],  width:7950, depth:4850},
    {dimension:[48,86], usecases:[{use:"Scooter", code:"PSH", capacity:"14no. Scooter"},{use:"Bin", code:"PBH", capacity:""}],  width:8550, depth:4850},
    {dimension:[48,92], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"53no. SV"},{use:"Hoop", code:"PCH", capacity:"44no. Hoop"}],  width:9150, depth:4850},
    {dimension:[48,98], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"56no. SV"},{use:"Hoop", code:"PCH", capacity:"48no. Hoop"},{use:"Scooter", code:"PSH", capacity:"16no. Scooter"},{use:"Bin", code:"PBH", capacity:""}],width:9750, depth:4850},
    {dimension:[48,104], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"60no. SV"},{use:"Hoop", code:"PCH", capacity:"52no. Hoop"}],  width:10350, depth:4850},
    {dimension:[48,110], usecases:[{use:"Scooter", code:"PSH", capacity:"18no. Scooter"},{use:"Bin", code:"PBH", capacity:""}],  width:10950, depth:4850},
    {dimension:[48,116], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"68no. SV"},{use:"Hoop", code:"PCH", capacity:"56no. Hoop"}],  width:11550, depth:4850},
    {dimension:[48,122], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"72no. SV"},{use:"Hoop", code:"PCH", capacity:"60no. Hoop"},{use:"Scooter", code:"PSH", capacity:"20no. Scooter"},{use:"Bin", code:"PBH", capacity:""}], width:12150, depth:4850},
    {dimension:[48,128], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"76no. SV"},{use:"Hoop", code:"PCH", capacity:"64no. Hoop"}],   width:12750, depth:4850},
    {dimension:[48,134], usecases:[{use:"Scooter", code:"PSH", capacity:"22no. Scooter"},{use:"Bin", code:"PBH", capacity:""}],   width:13350, depth:4850},
    {dimension:[48,140], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"84no. SV"},{use:"Hoop", code:"PCH", capacity:"68no. Hoop"}],   width:13950, depth:4850},
    {dimension:[48,146], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"88no. SV"},{use:"Hoop", code:"PCH", capacity:"72no. Hoop"},{use:"Scooter", code:"PSH", capacity:"24no. Scooter"},{use:"Bin", code:"PBH", capacity:""}], width:14550, depth:4850},
    {dimension:[48,152], usecases:[{use:"Semi-Vertical", code:"PCH", capacity:"92no. SV"},{use:"Hoop", code:"PCH", capacity:"76no. Hoop"}],   width:15150, depth:4850},

  ],
  dimension:[36,38],
  lastShedSize:[2,3],
  initialised:false,
  loadingProgress:0,
  appTitle: '',	
  mainPath: '',	
  mainModelLocation: '',	
  mainModelNames: [],	
  modelFileFormat: '',	
  arEnabled: false,	
  quantity: 1,
  type: 'Scooter',
  // mat	
  materialsLocation: '',	
  materialCategoryLocation: '',	
  defaultMaterials: {},	
  mainMenuEnabled: true,	
  mainSectionNavMenu: {},	
  showContactShadows: true,	
  autoRotate: false,	
  reset: false,	
  background: "light",
  // app loading / ready
  userDevice: '',
  appReady: false,
  
  get isLoaded() {
    return this.appReady;
  },
  
  get currUserDevice() {
    return this.userDevice;
  },
  
  // main menu
  
  get mainMenu() {
    return this.mainSectionNavMenu.menu;
  },
  
  get fileFormat() {
    return this.modelFileFormat;
  },
  //
  get folderLocation() {
    return this.mainModelLocation;
  },
  
  // main section selected
  get mainSectionSelected() {
    return this.mainSectionNavMenu.selected;
  },
  //
  get getCurrModels() {
    return this.mainModelNames;
  }
})
/*
   ------------------------------------------------------------
    set - main sections
*/

export const setLastShedSize = (value) => {
  state.lastShedSize = value;
}
// set selected config section
export const setSelectedMainSection = (value) => {
  state.mainSectionNavMenu.selected = value;
}

export const setLoadingProgress = (value) => {
  state.loadingProgress = value;
}


// set selected config section
export const setSelectedConfigSection = (value) => {
  configuratorState.configSectionNav.selected = value;
}

export const setQuantity = (newQuantity) => {
  state.quantity = newQuantity;
}

export const setType = (newType) => {
  state.type = newType;
}


/*
   ------------------------------------------------------------
   configurator section
*/
const initial_configuratorState = {
  
  /*
    main configurator section
 */
  
  configSectionNav: {},
  // menu
  get configMenu() {
    return this.configSectionNav.menu;
  },
  // config section selected
  get configSectionSelected() {
    return this.configSectionNav.selected;
  },
  
  /*
     features section
  */
  
  featuresMenu: {},
  partsGroupSelectorType: {},
  partsSelectorStatus: {},
  mainPartsMenu: {},
  modePartsGroupMap: {},
  
  // main features menu
  
  get featuresMenuNav() {
    return this.featuresMenu.menu;
  },
  
  // selected feature group
  get selectedFeaturePartsGroup() {
    return this.featuresMenu.selectedFeaturePartsGroup;
  },
  
  // selected parts menu
  get selectedPartsMenu() {
    return this.selectedFeaturePartsGroup && this.mainPartsMenu[this.selectedFeaturePartsGroup].menu;
  },
  
  // selected part
  get selectedPart() {
    return this.selectedFeaturePartsGroup && this.mainPartsMenu[this.selectedFeaturePartsGroup].selectedPart;
  },
  
  // state of parts displayed across the configurator
  get modelPartsSelectorStatus() {
    return this.partsSelectorStatus;
  },
  
  // selector type for this feature section - (radio / check)
  get selectedFeaturePartsGroupSelectorType() {
    
    return this.partsGroupSelectorType[this.selectedFeaturePartsGroup];
  },
  
  // give the model a selector type
  get modelGroupPartsMap() {
    return this.modePartsGroupMap;
  },
  
  /*
      materials section
  */
  materialMenusRef: [],
  mainMaterialSets: {},
  modelToMaterialRef: {},
  modelToGroupNameRef: {},
  modelToMaterialRefList: {},
  modelPartsMenu: {},
  modelMaterialGroupsMenu: {},
  
  modelMaterialFilterMenus: {},
  modelMaterialFilterType: 'manufacturer',
  modelMaterialFilterCurrent: 'all',

  materialsDeveloperControls: false,
  
   /*
      new UI state
  */
  shedSize:[0,0],
  selectedRoof:"FR",
  completed:false,
  showForm: false,
  wallStatus:{"wall1":false,"wall2":false,"wall3":false, "wall4":false, "roof":true},
  activeWall:"wall1",
  selectedStructure: "",
  selectedDoor: "none",
  selectedSecurity: "Digi",
  wall1State: false,
  wall1DoorPosition: "none",
  wall2State: false,
  wall2DoorPosition: "none",
  wall3State: false,
  wall3DoorPosition: "none",
  wall4State: false,
  wall4DoorPosition: "none",
  wallConfigStates:{"wall1":{structure:undefined, finish:undefined, door:"none", security:"Digi"},
  "wall2":{structure:undefined, finish:undefined, door:"none", security:"Digi"},"wall3":{structure:undefined, finish:undefined, door:"none", security:"Digi"}, "wall4":{structure:undefined, finish:undefined, door:"none", security:"Digi"}, "roof":{structure:"FR", finish:undefined, door:"none", security:"Digi"}, "active":"wall1"},
  //  parts menu - filtered based on model vis
  get filteredPartsMaterialMenu() {
    
    // no filtering required
    if (!chkObject(this.modelPartsSelectorStatus)) return this.modelPartsMenu.menu;
    
    // filter parts menu
    const modelPartsMenu = this.modelPartsMenu.menu;
    const filteredMenu = modelPartsMenu.filter(item => this.modelPartsSelectorStatus[item.title] === true);
    
    if(filteredMenu.length === 0)
    {
      console.warn("No filtered menus found, falling back to displaying all");
      return this.modelPartsMenu.menu;
    }

    // if filtered out is selected - choose next
    let selected = filteredMenu.find(mat => mat['title'] === this.modelPartsMenu.selected);
    if (selected === undefined) this.modelPartsMenu.selected = filteredMenu[0].title;
    // new menu
    return filteredMenu;
  },
  
  get materialMenusReference() {
    return this.materialMenusRef;
  },
  
  get materialMenu() {
    return this.modelPartsMenu.menu;
  },
  
  get partSelected() {
    return this.modelPartsMenu.selected;
  },
  
  // material menus & state
  get currMaterialGroupMenu() {
    return this.partSelected&&this.modelMaterialGroupsMenu[this.partSelected].menu;
  },
  
  get selectedMaterialGroup() {
    return this.partSelected&&this.modelMaterialGroupsMenu[this.partSelected].groupSelected;
  },
  
  // material sets (swatches)
  get materialSets() {
    return this.mainMaterialSets;
  },
  get activeMaterialSet() {
    return this.mainMaterialSets[this.selectedMaterialGroup];
  },
  get selectedMaterial() {
    return this.partSelected&&this.modelMaterialGroupsMenu[this.partSelected].selectedMaterial;
  },
  
  // materials filters
  get materialFilterCurrent() {
    return this.modelMaterialFilterCurrent;
  },
  
  get materialFilterMenus() {
    let filterSets = [];
    Object.keys(this.modelMaterialFilterMenus).forEach((prop) => {
      filterSets.push(this.modelMaterialFilterMenus[prop]);
    });
    return filterSets;
  },
  
  get newFilteredMaterials() {

    const FilteredMaterials = [];
    this.activeMaterialSet && this.activeMaterialSet.forEach((prop) => {
      const filter = prop['materialFilters'];
      if (filter === undefined || this.modelMaterialFilterCurrent === 'all' ||
        filter[this.modelMaterialFilterType] === this.modelMaterialFilterCurrent) {
        FilteredMaterials.push(prop);
      }
    });
    
    return FilteredMaterials;
  },
  
  
  // full material texturing & material settings data - textures, props, etc
  get activeMaterialSetData() {
    return this.mainMaterialSets[this.selectedMaterialGroup];
  },
  
  get activeMaterialData() {
    return this.activeMaterialSetData && this.activeMaterialSetData.find(mat => mat['title'] === this.selectedMaterial);
  },
  
  /*
      model to material mapping
  */
  // used in materials
  get modelToMaterialMap() {
    return this.modelToMaterialRefList;
  },
  // model group materials reference
  get currModelToMaterial() {
    // console.log(this.modelToMaterialRef)
    return this.modelToMaterialRef[this.partSelected];
  },
  
  get modelToMaterials() {
    // console.log(this.modelToMaterialRef)
    return this.modelToMaterialRef;
  },
  
  // model to part reference
  get modelToGroupName() {
    return this.modelToGroupNameRef;
  },
  
  /*
     ------------------------------------------------------------
     orientation section
  */
  orientationPartsMenu: {},
  orientationPartsData: {},
  orientationPartStatus: {},
  
  get orientationMenu() {
    return this.orientationPartsMenu.menu;
  },
  
  get selectedOrientationPart() {
    return this.orientationPartsMenu.selected;
  },
  
  get selectedOrientation() {
    return this.orientationPartsData[this.selectedOrientationPart]
  },
  
  get selectedOrientationDir() {
    if (this.orientationPartsData[this.selectedOrientationPart]) {
      return this.orientationPartsData[this.selectedOrientationPart].orientationSelected
    }
  },
  
  get filteredOrientationMenu() {
    
    // no filtering required
    if (!chkObject(this.modelPartsSelectorStatus)) return this.orientationPartsMenu.menu;
    
    // filter parts menu
    const modelPartsMenu = this.orientationPartsMenu.menu;
     if(true)
    {
      console.warn("No filtered menus found, falling back to displaying all");
      console.warn("Overriden as this is breaking things");
      return this.orientationPartsMenu.menu;
    }
    const filteredMenu = modelPartsMenu.filter(item => this.modelPartsSelectorStatus[item.title] === true);
    if(filteredMenu.length === 0)
    {
      console.warn("No filtered menus found, falling back to displaying all");
      return this.orientationPartsMenu.menu;
    }
    // if filtered out is selected - choose next
    let selected = filteredMenu.find(mat => mat['title'] === this.orientationPartsMenu.selected);
    if (filteredMenu[0] === undefined) return [];
    if (selected === undefined) this.orientationPartsMenu.selected = filteredMenu[0].title;
    // new menu
    return filteredMenu;
  },
  
  /*
     ------------------------------------------------------------
     specifications section
  */
  currentModelMaterialSpecifications: {},
  
  // material spec viewer
  get currMaterialSpecifications() {
    return this.currentModelMaterialSpecifications;
  },
  
  get filteredMaterialSpecifications() {
    
    if (!!Object.keys(this.currentModelMaterialSpecifications)[0]) {
      
      let modelPartsMenu = {...this.currentModelMaterialSpecifications};
      
      Object.keys(modelPartsMenu).forEach((prop) => {
        
        if (this.orientationPartsData && this.orientationPartsData[prop] !== undefined) {
          
          const orientation = this.orientationPartsData[prop].orientationSelected;
          modelPartsMenu[prop][2] = this.orientationPartsData[prop].orientationTags[orientation];
          
        }
        
        if (chkObject(this.modelPartsSelectorStatus) && this.modelPartsSelectorStatus[prop] !== true) {
          delete modelPartsMenu[prop];
        }
      });
      
      return Object.entries(modelPartsMenu);
    }
    
    return Object.entries(this.currentModelMaterialSpecifications);
  },
}
export let configuratorState = proxy(initial_configuratorState);

export const resetConfiguratorState = () =>{
 const resetObj = proxy(JSON.parse(JSON.stringify(initial_configuratorState)));
 Object.keys(resetObj).forEach((key) => {
  configuratorState[key] = resetObj[key]
 })
}

export const resetModulesBState = () =>{
 const resetObj = proxy(JSON.parse(JSON.stringify(initialModulesBState)));
 Object.keys(resetObj).forEach((key) => {
  modulesBState[key] = resetObj[key]
 })
}

export const resetModulesState = () =>{
 const resetObj = proxy(JSON.parse(JSON.stringify(initialModulesState)));
 Object.keys(resetObj).forEach((key) => {
  modulesState[key] = resetObj[key]
 })
}

export const resetPanelsBState = () =>{
 const resetObj = proxy(JSON.parse(JSON.stringify(initialPanelsState)));
 Object.keys(resetObj).forEach((key) => {
  panelsState[key] = resetObj[key]
 })
}
/*
   ------------------------------------------------------------
    set - mew UI section
*/
export const activateWall = (value) => {
  configuratorState.wallStatus[value] = true;
}
export const setActiveWall = (value) => {
  configuratorState.activeWall = value;
}
export const setShedSize = (value) => {
  configuratorState.shedSize = value;
}
export const setSecurity = (wall,value) => {
  configuratorState.selectedSecurity = value;
  configuratorState.wallConfigStates[wall].security=value;
}

export const setDoor = (wall,value) => {
  configuratorState.selectedDoor = value;
  configuratorState.wallConfigStates[wall].door=value;
}
export const setCompleted = (value) => {
  configuratorState.completed = value;
}
export const setShowForm = (value) => {
  configuratorState.showForm = value;
}

export const setRoof = (wall,value) => {
  configuratorState.selectedRoof = value;
  configuratorState.wallConfigStates[wall].structure=value;
}
export const setSelectedStructure = (value) => {
  configuratorState.selectedStructure = value;
}
export const setWallStructure = (wall,value) => {
  configuratorState.wallConfigStates[wall].structure = value;
}

export const setWall1State = (value) => {
  configuratorState.wall1State = value;
}

export const setWall1DoorPosition = (value) => {
  configuratorState.wall1DoorPosition = value;
}

export const setWall2State = (value) => {
  configuratorState.wall2State = value;
}

export const setWall2DoorPosition = (value) => {
  configuratorState.wall2DoorPosition = value;
}
export const setWall3DoorPosition = (value) => {
  configuratorState.wall3DoorPosition = value;
}
export const setWall4DoorPosition = (value) => {
  configuratorState.wall4DoorPosition = value;
}

export const setWallConfigStates = (key,value) => {
  configuratorState.wallConfigStates[key] = value;
  configuratorState.wallConfigStates.active=key;
}

export const setFinish = (key,value) => {
  configuratorState.wallConfigStates[key].finish = value;
  for (const wall in configuratorState.wallConfigStates){
    if(wall !== key && (
      configuratorState.wallConfigStates[wall].structure === configuratorState.wallConfigStates[key].structure ||
      ((configuratorState.wallConfigStates[key].structure === "Vert-Timber" || configuratorState.wallConfigStates[key].structure === "Horiz-Timber" || configuratorState.wallConfigStates[key].structure === "TGV") && (configuratorState.wallConfigStates[wall].structure === "Vert-Timber" || configuratorState.wallConfigStates[wall].structure === "Horiz-Timber" || configuratorState.wallConfigStates[wall].structure === "TGV")))     
      ){
      configuratorState.wallConfigStates[wall].finish = value;
    }
  }
}

export const setWallConfigDoorStates = (key,value) => {
  configuratorState.wallConfigStates[key].door = value;
}


/*
   ------------------------------------------------------------
   loading materials
*/
export const materialLoadingState = proxy({
  loadState: 'ready',
  get matLoadingState() {
    return this.loadState;
  }
});

/*
   ------------------------------------------------------------
   ar section
*/
export const arState = proxy({
  
  arGroupVis: true,
  
  get getGroupVis() {
    return this.arGroupVis;
  }
  
});

export const setGroupVis = (val) => {
  arState.arGroupVis = val;
}

/*
   ------------------------------------------------------------
   camera section
*/
export const cameraState = proxy({
  
  camera: {},
  saveImage: false,
  currCamPosition: 0,
  camPositions: {},
  developerControls: false,
  minDistance: 7.4,
  defaultPosition: {	
    x: 0,	
    y: 2,	
    z: 5	
  },	
  defaultTarget: {	
    x: 0,	
    y: 0,	
    z: 0	
  },
  get developerControlsStatus() {
    return this.developerControls;
  },
  
  modulesLastContainerPosition: {},
  modulesCurrContainerPosition: {},
  modulesContainerCenter: '',
  
  get getModulesContainerData() {
    return {
      modulesCurrContainerPosition: this.modulesCurrContainerPosition,
      modulesLastContainerPosition: this.modulesLastContainerPosition,
      modulesContainerCenter: this.modulesContainerCenter
    };
  },
  
  get camaraPositions() {
    return chkObject(this.camPositions) ? this.camPositions : false;
  },
  
  get currentCamPos() {
    return this.currCamPosition;
  },
  
  get camPositionsTotal() {
    return Object.keys(this.camPositions).length;
  }
  
});
export const setMinDistance = (newDistance) => {
  cameraState.minDistance = newDistance;
}
export const setSaveImage = (save = true) => {
  cameraState.saveImage = save;
}
export const setCamera = (camera) => {
  cameraState.camera = camera;
}
export const setCameraAngle = (value) => {
  if (value < cameraState.camPositionsTotal) {
      cameraState.currCamPosition = value;
  }
}

export const setCameraPos = (status) => {
  
  if (status === 'index_forward') {
    cameraState.currCamPosition += 1;
    if (cameraState.currCamPosition >= cameraState.camPositionsTotal) {
      cameraState.currCamPosition = 0;
    }
    
  } else {
    cameraState.currCamPosition -= 1;
    if (cameraState.currCamPosition < 0) {
      cameraState.currCamPosition = cameraState.camPositionsTotal - 1;
    }
  }
}


export const setModulesContainerPosition = (value) => {
  cameraState.modulesLastContainerPosition = cameraState.modulesCurrContainerPosition
  cameraState.modulesCurrContainerPosition = value.containerSize;
  cameraState.modulesContainerCenter = value.containerCenter;
}

/*
   ------------------------------------------------------------
    set - features section
*/
// set selected main features
export const setSelectedMainFeature = (value) => {
  configuratorState.featuresMenu.selectedFeature = value;
}

// set selected features group
export const setSelectedMainFeatureMenu = (value) => {
  configuratorState.featuresMenu.selectedFeaturePartsGroup = value;
}

// set selected part - radio btn
export const setSelectedPartRadioBtn = (value) => {
  if(['Steel', 'Concrete', 'Green Roof'].includes(value))
  {
    panelsState.spec['Roof Type'] = value;
  }
  const pSelectors = configuratorState.modelPartsSelectorStatus;
  configuratorState.selectedPartsMenu.forEach((item) => {
    pSelectors[item.title] = false
  });
  pSelectors[value] = true;
}

// set selected part - check btn
export const setSelectedPartCheckBtn = (value) => {
  const pSelectors = configuratorState.modelPartsSelectorStatus;
  pSelectors[value] = !pSelectors[value];
}

/*
   ------------------------------------------------------------
   set - materials section
*/
export const setSelectedModelPart = (value) => {
  configuratorState.modelPartsMenu.selected = value;
}

export const setSelectedMaterialGroup = (value) => {
  configuratorState.modelMaterialGroupsMenu[configuratorState.partSelected].groupSelected = value;
}

export const setSelectedMaterial = (value) => {
  configuratorState.modelMaterialGroupsMenu?configuratorState.modelMaterialGroupsMenu[configuratorState.partSelected].selectedMaterial = value:null
}

export const setMaterialLoadingState = (value) => {
  materialLoadingState.loadState = value;
}

/*
   ------------------------------------------------------------
   set - filters section
*/
export const setCurrentMaterialFilter = (value) => {
  configuratorState.modelMaterialFilterCurrent = value;
}

/*
   ------------------------------------------------------------
   set - orientation section
*/
// set selected part for orientation
export const setSelectedOrientationPart = (value) => {
  configuratorState.orientationPartsMenu.selected = value;
}

// set selected part orientation
export const setPartOrientation = () => {
  let orientationFlip = configuratorState.selectedOrientation;
  orientationFlip.orientationSelected === 1 ?
    orientationFlip.orientationSelected = 0 :
    orientationFlip.orientationSelected = 1;
}

/*
   ------------------------------------------------------------
   set - mat specs section
*/
export const setCurrentModelMaterialSpecifications = (part, mat) => {
  part && (configuratorState.currentModelMaterialSpecifications[part] = mat);
}

/*
   ------------------------------------------------------------
   model module state
*/
const initialModulesState = {
  
  modelModules: [],
  activeModulesList: [],
  
  modulesStatus: 'add',
  moduleSideRef: 'left',
  moduleRefLeft: 0,
  moduleRefRight: 0,
  
  collisionChkStatus: 'inactive',
  
  collisionModule: 'none',
  
  get collisionModuleDetected() {
    return this.collisionModule;
  },
  
  get removedModuleStatus() {
    return this.moduleSideRef;
  },
  
  get collisionCheckStatus() {
    return this.collisionChkStatus;
  },
  
  get activeModulesStatus() {
    return this.modulesStatus;
  },
  
  get activeModules() {
    return this.activeModulesList;
  }
  
}
export const modulesState = proxy(initialModulesState);

/*
   ----------------------------------------------------------------------------------
    set - module state
*/

export const setAddAllModules = (modules) => {
  modulesState.modelModulesRefs = modules;
}

export const setCollisionCheckStatus = (value) => {
  modulesState.collisionChkStatus = value;
}

export const setCollisionModule = (value) => {
  modulesState.collisionModule = value;
}

export const addModule = (module, first) => {
  
  if (module.dir === 'left' && first) {
    
    module.ref = 0;
    modulesState.moduleRefLeft = 0;
    modulesState.modulesStatus = 'add';
    modulesState.activeModulesList[0] = module;
    return;
  }
  
  if (module.dir === 'left') {
    
    modulesState.moduleRefLeft += 1;
    module.ref = modulesState.moduleRefLeft;
    
  } else if (module.dir === 'right') {
    
    module.ref = modulesState.moduleRefRight;
    modulesState.moduleRefRight += 1;
  }
  
  modulesState.modulesStatus = 'add';
  modulesState.activeModulesList.push(module);
}

export const setRemoveModuleLeft = () => {
  
  modulesState.moduleSideRef = 'left';
  modulesState.modulesStatus = 'remove';
  
  modulesState.moduleRefLeft -= 1;
  modulesState.moduleRefLeft < 1 && (modulesState.moduleRefLeft = 1)
  
  let i = 0;
  modulesState.activeModulesList.forEach((item, index) => {
    item.dir === 'left' && (i = index);
  });
  
  modulesState.activeModulesList.splice(i, 1);
  modulesState.collisionModule = 'none';
}

export const removeLeftWall = () => {
  
  modulesState.moduleSideRef = 'left';
  modulesState.modulesStatus = 'remove';
  
  modulesState.moduleRefLeft -= 1;
  modulesState.moduleRefLeft < 1 && (modulesState.moduleRefLeft = 1)
  
  let i_ =0;
  let counter = modulesState.activeModulesList.length
  while (counter--) {
    if(modulesState.activeModulesList[counter].dir==="left" && modulesState.activeModulesList[counter].name!=="datum-node"){
        modulesState.activeModulesList.splice(counter, 1);
      } 
  }
  modulesState.collisionModule = 'none';
}

export const removeRightWall = () => {
  
  modulesState.moduleSideRef = 'right';
  modulesState.modulesStatus = 'remove';
  
  modulesState.moduleRefRight -= 1;
  modulesState.moduleRefRight < 1 && (modulesState.moduleRefRight = 1)
  
  let i_ =0;
  let counter = modulesState.activeModulesList.length
  while (counter--) {
    if(modulesState.activeModulesList[counter].dir==="right" && modulesState.activeModulesList[counter].name!=="datum-node"){
        modulesState.activeModulesList.splice(counter, 1);
      } 
  }
  modulesState.collisionModule = 'none';
}

export const setRemoveModuleRight = () => {
  
  modulesState.moduleSideRef = 'right';
  modulesState.modulesStatus = 'remove';
  
  modulesState.moduleRefRight -= 1;
  modulesState.moduleRefRight < 0 && (modulesState.moduleRefRight = 0);
  
  let i = 0;
  modulesState.activeModulesList.forEach((item, index) => {
    item.dir === 'right' && (i = index);
  });
  
  modulesState.activeModulesList.splice(i, 1);
  modulesState.collisionModule = 'none';
}


/*
   ----------------------------------------------------------------------------------
    set - moduleB state
*/
const initialModulesBState = {
  
  modelModules: [],
  activeModulesList: [],
  
  modulesStatus: 'add',
  moduleSideRef: 'left',
  moduleRefLeft: 0,
  moduleRefRight: 0,
  
  
  get removedModuleBStatus() {
    return this.moduleSideRef;
  },
  
  get activeModulesBStatus() {
    return this.modulesStatus;
  },
  
  get activeModulesB() {
    return this.activeModulesList;
  }
  
}
export const modulesBState = proxy(initialModulesBState);

const initialPanelsState = {
  
  maxTotalLeft: 12910,
  maxTotalRight: 3329,
  
  panelsFrontLeft: 0,
  panelsFrontRight: 0,
  panelsBackLeft: 0,
  panelsBackRight: 0,
  
  lastFrontLeft: false,
  lastBackLeft: false,
  spec: {
    "Wall 1": '',
    "Wall 2": '',
    "Wall 3": '',
    "Wall 4": '',
    "Roof Type": 'Steel'
  },
  
  get panelTotals() {
    
    return {
      panelsFrontLeft: this.panelsFrontLeft,
      panelsFrontRight: this.panelsFrontRight,
      panelsBackLeft: this.panelsBackLeft,
      panelsBackRight: this.panelsBackRight
    }
  },
  
  get panelMaxTotals() {
    
    return {
      maxTotalLeft: this.maxTotalLeft,
      maxTotalRight: this.maxTotalRight
    }
  },
  
  get panelLast() {
    
    return {
      lastFrontLeft: this.lastFrontLeft,
      lastBackLeft: this.lastBackLeft
    }
  },
  
}
export const panelsState = proxy(initialPanelsState);

export const setPanelMaxTotals = (totalLeft, totalRight) => {
  panelsState.maxTotalLeft = totalLeft;
  panelsState.maxTotalRight = totalRight;
}

export const setSpec = (index, newValue) => {
  panelsState.spec[index] = newValue;
}

export const addPanelTotals = (totalL, totalR, orientation) => {
  
  switch (orientation) {
    
    case 'front': {
      panelsState.panelsFrontLeft = totalL;
      panelsState.panelsFrontRight = totalR;
      break;
    }
    case 'back': {
      panelsState.panelsBackLeft = totalL;
      panelsState.panelsBackRight = totalR;
      break;
    }
  }
}

export const setLastPanel = (orientation, state) => {
  
  // console.log('setLastPanel', orientation, state)
  
  switch (orientation) {
    
    case 'front': {
      panelsState.lastFrontLeft = state;
      break;
    }
    case 'back': {
      panelsState.lastBackLeft = state;
      break;
    }
  }
}


/*
   ----------------------------------------------------------------------------------
    set - moduleB state
*/

export const addModuleB = (module, first) => {
  
  if (module.dir === 'left' && first) {
    
    module.ref = 0;
    modulesBState.moduleRefLeft = 0;
    modulesBState.modulesStatus = 'add';
    modulesBState.activeModulesList[0] = module;
    return;
  }
  
  if (module.dir === 'left') {
    
    modulesBState.moduleRefLeft += 1;
    module.ref = modulesBState.moduleRefLeft;
    
  } else if (module.dir === 'right') {
    
    module.ref = modulesBState.moduleRefRight;
    modulesBState.moduleRefRight += 1;
  }
  
  modulesBState.modulesStatus = 'add';
  modulesBState.activeModulesList.push(module);
}

export const setRemoveModuleBLeft = () => {
  
  modulesBState.moduleSideRef = 'left';
  modulesBState.modulesStatus = 'remove';
  
  modulesBState.moduleRefLeft -= 1;
  modulesBState.moduleRefLeft < 1 && (modulesBState.moduleRefLeft = 1)
  
  let i = 0;
  modulesBState.activeModulesList.forEach((item, index) => {
    item.dir === 'left' && (i = index);
  });
  
  modulesBState.activeModulesList.splice(i, 1);
  modulesBState.collisionModule = 'none';
}

export const removeBLeftWall = () => {
  modulesBState.moduleSideRef = 'left';
  modulesBState.modulesStatus = 'remove';
  
  modulesBState.moduleRefLeft -= 1;
  modulesBState.moduleRefLeft < 1 && (modulesBState.moduleRefLeft = 1)
  
  let i_ =0;
  let counter = modulesBState.activeModulesList.length
  while (counter--) {
    if(modulesBState.activeModulesList[counter].dir==="left" && modulesBState.activeModulesList[counter].name!=="datum-node"){
        modulesBState.activeModulesList.splice(counter, 1);
      } 
  }

  modulesBState.collisionModule = 'none';
}

export const setRemoveModuleBRight = () => {
  
  modulesBState.moduleSideRef = 'right';
  modulesBState.modulesStatus = 'remove';
  
  modulesBState.moduleRefRight -= 1;
  modulesBState.moduleRefRight < 0 && (modulesBState.moduleRefRight = 0);
  
  let i = 0;
  modulesBState.activeModulesList.forEach((item, index) => {
    item.dir === 'right' && (i = index);
  });
  
  modulesBState.activeModulesList.splice(i, 1);
  modulesBState.collisionModule = 'none';
}

export const removeBRightWall = () => {
  
  modulesBState.moduleSideRef = 'right';
  modulesBState.modulesStatus = 'remove';
  
  modulesBState.moduleRefRight -= 1;
  modulesBState.moduleRefRight < 1 && (modulesBState.moduleRefRight = 1)

  let i_ =0;
  let counter = modulesBState.activeModulesList.length
  while (counter--) {
    if(modulesBState.activeModulesList[counter].dir==="right" && modulesBState.activeModulesList[counter].name!=="datum-node"){
        modulesBState.activeModulesList.splice(counter, 1);
      } 
  }

  modulesBState.collisionModule = 'none';
}

/*
   ----------------------------------------------------------------------------------
    set - custom scripts state
*/

export const customScriptState = proxy({

  scripts: {},

});

export const addScript = (scriptPath) => {
  const scriptPathArray = scriptPath.split('/');
  const pathToScript = scriptPathArray.slice(0, -1).join('/') + "/";
  const scriptName = scriptPathArray[scriptPathArray.length - 1].split('.').slice(0, -1).join('.');

  fetch(scriptPath)
  .then(response => response.text())
  .then(txt => customScriptState.scripts[scriptName] = eval(txt))
  //.then(txt => console.log(txt))
  //.then(() => {
  //  document.getElementById('status').innerHTML = 'moment.min.js loaded'
  //  // now you can use the script
  //  document.getElementById('today').innerHTML = moment().format('dddd');
  //  document.getElementById('today').style.color = 'green';
  //  })

  //const scriptPromise = new Promise((resolve, reject) => {
  //  const script = document.createElement('script');
  //  document.body.appendChild(script);
  //  script.onload = resolve;
  //  script.onerror = reject;
  //  script.async = true;
  //  script.src = scriptPath;
  //});
  
  //scriptPromise.then((res) => { console.log(res); });

  //fetch(scriptPath).then(s => console.log(s));

  //new Promise.all(dataUrls.map(url => fetch(url)
  //    
  //    .then(r => r.json()))).then(([data1, data2]) => {
  //    
  //    formatData(data1, data2);
  //    
  //  }).catch(error => console.log('error - getting data', error))
  //console.log("scriptName", scriptName);
  //console.log("pathToScript", pathToScript);
}

export const runScript = (scriptData) =>
{
  const scriptName = Object.keys(scriptData).shift();
  const scriptArgs = Object.values(scriptData).shift();
  
  customScriptState.scripts[scriptName](scriptArgs);
}


/* #endregion*/
/* #region Lighting*/
export const lightingState = proxy({
  developerControls: false,
  lights: {},
  get getLightArray()
  {
    let lightsArray = [];
    Object.keys(this.lights).forEach(lightKey=>
    {
      lightsArray.push(this.lights[lightKey]);
    });
    // console.log(lightsArray);
    return lightsArray;
  },
});
export const addLight = (newLightName, newLightData) =>
{
  newLightData.name = newLightName;
  lightingState.lights[newLightName] = newLightData;
  // console.log("Adding light \"" + newLightName + "\" with data", newLightData);
}
/* #endregion */


/*pre configurator start*/
export const setDimension = (value) => {
  state.dimension=value;
}

export const setInitialised = (value) => {
  state.initialised = value;
  if(!value){
    resetConfiguratorState()
    resetModulesBState()
    resetModulesState()
    resetPanelsBState()
  }

}

export const setUsecase = (value) => {
  state.usecase = value;
}